import React from "react";
import { withTranslation } from "react-i18next";
import i18n from "i18n/i18n";
import PropTypes from "prop-types";
import { Icons, Button } from "@texada/ui";
import Heading from "../uis/navbar/heading/Heading";
import "./ErrorPage.scss";

const ErrorPage = props => {
  const { title, devError, icon } = props;

  return (
    <div className={`error-page-${devError ? "dev" : "friendly"}`}>
      <Heading title={title} />
      {devError ? (
        <>{props.children}</>
      ) : (
        <div className="error-page-friendly-centered">
          {icon}
          {props.children}
          <Button
            as="a"
            buttonProps={{
              href: "https://texadasoftware.com/support/",
              target: "_blank"
            }}
          >
          {i18n.t("go_to_texada_support")}
          </Button>
        </div>
      )}
    </div>
  );
};

ErrorPage.propTypes = {
  devError: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.element
};

ErrorPage.defaultProps = {
  devError: false,
  title: i18n.t("oops_something_went_wrong"),
  icon: <Icons.Warning />
};

export default withTranslation()(ErrorPage);
